import React,{useRef,useEffect} from 'react';
import { emptyCheck, numCheck} from './toolFunction';

function InputTextArea(props){
    let isOnComposition = false; 
   const inputRef=useRef("");  
   const setInputValue = () => {  inputRef.current.value = (props.inputState || ' ').trimStart() || ' ' ;  };

    useEffect(() => { setInputValue()      });

   const handleComposition = evt => {
    
    if (evt.type === 'compositionend') {       
      isOnComposition = false;
    //   if (navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('Trident') > -1) {
    //      // console.log('Chrome')
    //       handleChange(evt);
    //   }
      handleChange(evt);
      return;
    }
   
    isOnComposition = true;
  };
  const handleChange= event => {
    //props.inputName, props.stateObj, props.checkValue, props.title, props.required
    if (!isOnComposition) {           
        //console.log('handleChange:'+isOnComposition)
        let word = event.target.value.trimStart();
        if(event.target.value.length >0){ 
            if (props.required === true){
                word = emptyCheck(word, props.title, props.stateObj.state[props.inputName])
            }
        } else { word = " "; }  

        if (props.required === false && event.target.value.length === 0) { word = " "};
        word = numCheck(word, props.checkValue,props.title ); 
        //console.log('word:'+word)
       
            props.stateObj.setState({ ...props.stateObj.state, [props.inputName]: word});
        }
    
    }   
    const commonProps = {
        onChange: handleChange,  
        onCompositionStart: handleComposition,   
        onCompositionUpdate: handleComposition,   
        onCompositionEnd: handleComposition,
    };


    return(


        <div className="form-row">
            <label>
                { props.required &&
                    <span className='text-danger'>*</span>
                }
                {props.title} 
                <em className='text-primary'>{props.notice} </em> 
            </label>
            <textarea className={`form-control`} id={props.inputName} placeholder={props.title} rows={props.rows} ref={inputRef}  {...commonProps} />

            {/* <textarea  className={`form-control`} id={props.inputName} placeholder={props.title}   rows={props.rows}
            value={props.inputState} onChange={handleChange(props.inputName, props.stateObj,props.checkValue, props.title )}  required={props.required} /> */}          

            { /*props.required &&
                <div className="invalid-feedback">
                    {props.title}不可以空白
                </div>*/
            }

        </div>

    )
}

export default InputTextArea;